export const ANALYTICS_EVENTS = {
  PAGE_VIEW: '$pageview',
  BUTTON_CLICKED: 'button_clicked',

  LOGIN_SUBMITTED: 'login_submitted',
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAILED: 'login_failed',
  SIGNUP_SUBMITTED: 'signup_submitted',
  SIGNUP_SUCCESS: 'signup_success',
  SIGNUP_FAILED: 'signup_failed',
  FORGOT_PASSWORD_SUBMITTED: 'forgot_password_submitted',
  FORGOT_PASSWORD_FAILED: 'forgot_password_failed',
  RESET_PASSWORD_SUBMITTED: 'reset_password_submitted',
  LOGOUT: 'logout',

  NAV_DASHBOARD: 'nav_dashboard',
  NAV_SETTINGS: 'nav_settings',
  NAV_CLIENT_SELECTED: 'nav_client_selected',
  NAV_NEW_CLIENT: 'nav_new_client',
  NAV_SIDEBAR_TOGGLED: 'nav_sidebar_toggled',

  CLIENT_CREATED: 'client_created',
  CLIENT_EDITED: 'client_edited',
  CLIENT_TAB_CHANGED: 'client_tab_changed',

  RESEARCH_STEP_COMPLETED: 'research_step_completed',
  RESEARCH_CREATED: 'research_created',
  RESEARCH_DELETED: 'research_deleted',
  RESEARCH_MEMO_GENERATED: 'research_memo_generated',
  RESEARCH_MEMO_DOWNLOADED: 'research_memo_downloaded',
  RESEARCH_ENHANCED: 'research_enhanced',
  RESEARCH_UPDATED: 'research_updated',

  DOCUMENT_UPLOADED: 'document_uploaded',
  DOCUMENT_DOWNLOADED: 'document_downloaded',
  DOCUMENT_DELETED: 'document_deleted',
  DOCUMENT_ANALYZED: 'document_analyzed',

  CONTRACT_REVIEW_STARTED: 'contract_review_started',

  SEARCH_PERFORMED: 'search_performed',
  SEARCH_RESULT_CLICKED: 'search_result_clicked',

  SETTINGS_SAVED: 'settings_saved',
  SETTINGS_THEME_CHANGED: 'settings_theme_changed',
  SETTINGS_DISPLAY_MODE_CHANGED: 'settings_display_mode_changed',

  CONTACT_FORM_SUBMITTED: 'contact_form_submitted',

  ACTION_BOX_CLICKED: 'action_box_clicked',

  WORKFLOW_COMPLETED: 'workflow_completed',

  API_ERROR: 'api_error',
} as const;
